/**
 * SGKE061A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BasicInfo {

    /**
     * 返金管理番号
     */
    repayMno?: string;
    /**
     * 返金額
     */
    repayMny?: number;
    /**
     * 未精算金管理番号
     */
    kinkoMno?: string;
    /**
     * 未精算金履歴番号
     */
    kinkoRrkno?: string;
    /**
     * 返金実績_更新通番号
     */
    repayAchievUpdateSrno?: string;
    /**
     * 返金実績EX_更新通番号
     */
    repayachievexUpdatesequencenumber?: string;
}

